import { Formik } from "formik"
import { useForgotPassword } from "hooks/auth"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Button, Form, FormFeedback, Input, Label, Alert } from "reactstrap"
import { Loading } from "components"

import schema from "./schema"

const LoginForm = () => {
  const [showErrorAlert, setShowErrorAlert] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const forgotPassword = useForgotPassword()

  useEffect(() => {
    const wrongArguments = forgotPassword.error?.error_type === "WrongArguments"
    if (forgotPassword.isError && wrongArguments) setShowErrorAlert(true)
  }, [forgotPassword.isError])

  useEffect(() => {
    if (forgotPassword.isSuccess) setShowSuccessAlert(true)
  }, [forgotPassword.isSuccess])

  const handleOnSubmit = (values) => {
    forgotPassword.mutate(values)
  }

  const isLoading = forgotPassword.isLoading

  return (
    <Formik
      enableReinitialize
      initialValues={{
        email: "",
      }}
      validationSchema={schema}
      onSubmit={handleOnSubmit}
    >
      {({ values, handleChange, handleSubmit, handleBlur, touched, errors }) => (
        <Form className="form-horizontal" onSubmit={handleSubmit}>
          <Alert color="danger" isOpen={showErrorAlert} toggle={() => setShowErrorAlert(false)}>
            {forgotPassword.error?.errors?.map((error) => error?.message)}
          </Alert>
          <Alert color="success" isOpen={showSuccessAlert} toggle={() => showSuccessAlert(false)}>
            Se ha enviado un enlace de recuperación de contraseña al correo ingresado.
          </Alert>

          <div className="mb-3">
            <Label className="form-label">Email</Label>
            <Input
              name="email"
              className="form-control"
              type="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              invalid={!!(touched.email && errors.email)}
            />
            {touched.email && errors.email && <FormFeedback type="invalid">{errors.email}</FormFeedback>}
          </div>

          <div className="mt-3 d-grid">
            <Button color="dark" type="submit" disabled={isLoading}>
              <Loading isLoading={isLoading} /> Enviar
            </Button>
          </div>

          <div className="mt-4 text-center">
            <Link to="/login" className="text-muted">
              <i className="mdi mdi-lock me-1" />
              Inicia sesión!
            </Link>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default LoginForm
